import { History } from "lucide-react";

const when = (t) => new Date(t).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
const time = (t) => new Date(t).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });

/** Bandeau : une version non enregistrée a été retrouvée sur cet appareil. */
export function DraftBanner({ draft, onRestore }) {
  if (!draft.pending) return null;
  return (
    <div className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border border-amber-500/30 bg-amber-500/[0.07] px-4 py-3 text-sm" data-testid="draft-banner">
      <History className="w-4 h-4 text-amber-300 shrink-0" />
      <span className="flex-1 min-w-[16rem] text-zinc-200">
        <b className="text-amber-200">Une version non enregistrée a été retrouvée</b> (le {when(draft.pending.at)}). Voulez-vous la récupérer ?
      </span>
      <button type="button" onClick={() => { const d = draft.restore(); if (d) onRestore(d); }} className="h-8 px-3 rounded-md text-xs font-medium bg-emerald-500 text-black hover:bg-emerald-300" data-testid="draft-restore">
        Récupérer
      </button>
      <button type="button" onClick={draft.discard} className="h-8 px-3 rounded-md text-xs border border-white/10 hover:bg-white/5" data-testid="draft-discard">
        Ignorer
      </button>
    </div>
  );
}

/** Ligne d'état sous « Enregistrer ». */
export function DraftStatus({ draft }) {
  return (
    <p className="text-[11px] text-zinc-500 leading-relaxed" data-testid="draft-status">
      {draft.savedAt
        ? `Brouillon sauvegardé sur cet appareil à ${time(draft.savedAt)}. Pensez à « Enregistrer » pour publier.`
        : "Pendant que vous écrivez, un brouillon est sauvegardé automatiquement sur cet appareil."}
    </p>
  );
}
